module.exports = __webpack_public_path__ + "static/media/cesped-sintetico.470ed24a.jpg";